





















































import Vue from "vue";
import {
  VUEX_LEARNING_HISTORY_ACTION_NAMES,
  VUEX_LEARNING_HISTORY_NAMESPACE
} from "@tt-app/constants";

import IconClose from "@joyz/app-core/assets/icons/transparent/Close.svg";
import IconFeedbackEasy from "@joyz/app-core/assets/emoji/FeedbackEasy.png";
import IconFeedbackModerate from "@joyz/app-core/assets/emoji/FeedbackModerate.png";
import IconFeedbackDifficult from "@joyz/app-core/assets/emoji/FeedbackDifficult.png";
import ImageSent from "@joyz/app-core/assets/feedback/sent.png";

interface Data {
  icons: {
    [key: string]: string;
  };
  levels: {
    emoji: string;
    label: string;
  }[];
  selectedIndex: null | number;
  submitted: boolean;
}

interface Methods {
  closeFeedback: () => void;
  handleCloseClick: (event: MouseEvent) => void;
  handleLevelClick: (selectedIndex: number) => void;
  handleSubmitClick: () => void;
}

interface Computed {
  showSecondaryInput: boolean;
  submitDisabled: boolean;
}

interface Props {
  logId: string;
  onMobile: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "FeedbackCard",

  props: {
    logId: {
      type: String,
      default: undefined
    },
    onMobile: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      icons: {
        close: IconClose
      },
      images: {
        sent: ImageSent
      },
      levels: [
        {
          emoji: IconFeedbackEasy,
          label: this.$__("feedback.level.easy")
        },
        {
          emoji: IconFeedbackModerate,
          label: this.$__("feedback.level.moderate")
        },
        {
          emoji: IconFeedbackDifficult,
          label: this.$__("feedback.level.difficult")
        }
      ],
      selectedIndex: null,
      submitted: false
    };
  },

  computed: {
    showSecondaryInput() {
      return this.onMobile || this.selectedIndex !== null;
    },

    submitDisabled() {
      return this.selectedIndex === null;
    }
  },

  methods: {
    closeFeedback() {
      this.$emit("close");
    },
    handleCloseClick(event) {
      event.stopPropagation();
      this.closeFeedback();
    },

    handleLevelClick(selectedIndex) {
      this.selectedIndex = selectedIndex;
    },

    handleSubmitClick() {
      if (this.selectedIndex === null) return;

      const userFeedback = this.$refs["user-feedback"] as HTMLTextAreaElement;

      this.$store.dispatch(
        `${VUEX_LEARNING_HISTORY_NAMESPACE}/${VUEX_LEARNING_HISTORY_ACTION_NAMES.SEND_FEEDBACK}`,
        {
          logId: this.logId,
          comment: userFeedback.value,
          rating: this.selectedIndex + 1
        }
      );

      this.submitted = true;
      this.$emit("submitted");

      setTimeout(() => {
        this.closeFeedback();
      }, 2000);
    }
  }
});
